// Lib
import * as _ from 'lodash';
import { put, call, takeLatest } from "redux-saga/effects";

// Constants
import * as ACTIONS from "./actionTypes";

// Functions
import { createAPIUnsecureNetworkInstance, createAPINetworkInstance } from '../../../common/api';

// Types
import { postLoginError, ActionLoginApi, postLoginApiSuccess, postUserDataApi, postUserDataApiSuccess, postUserDataError, getPlatformSecurityApiSuccess, getPlatformSecurityError } from './actions';

function* postLogin(action: ActionLoginApi) {
    try {
        const { loggedInObject } = action as ActionLoginApi
        const body = {
            "secret": loggedInObject.access_token,
            "metadata": JSON.stringify({ profile: loggedInObject.profile })
        }
        const { data } = yield call(createAPIUnsecureNetworkInstance().post, `security/session`, body);
        yield put(postLoginApiSuccess(data.token, data.user));
    } catch (err) {
        yield put(postLoginError(err));
    }
}

function* postUserData(action: ActionLoginApi) {
    try {
        const { loggedInObject } = action as ActionLoginApi
        const body = {
            "secret": loggedInObject.access_token,
            "metadata": JSON.stringify({ profile: loggedInObject.profile })
        }
        const { data } = yield call(createAPIUnsecureNetworkInstance().post, `security/getuserdata`, body);
        yield put(postUserDataApiSuccess(data.token, data.user));
    } catch (err) {
        yield put(postUserDataError(err));
    }
}

function* getPlatformSecurity() {
    try {
        const { data } = yield call(createAPINetworkInstance().get, `security/platform-security`);
        yield put(getPlatformSecurityApiSuccess(data));
    } catch (err) {
        yield put(getPlatformSecurityError(err));
    }
}

export default function* securitySagas() {
    yield takeLatest(ACTIONS.POST_LOGIN_API_REQUEST, postLogin);
    yield takeLatest(ACTIONS.POST_USERDATA_API_REQUEST, postUserData);
    yield takeLatest(ACTIONS.GET_PLATFORM_SECURITY_API_REQUEST, getPlatformSecurity);
}
